"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var SignalingClientEventType_1 = require("../signalingclient/SignalingClientEventType");

var BaseTask_1 = require("./BaseTask");

var CleanStoppedSessionTask = /*#__PURE__*/function (_BaseTask_1$default) {
  _inherits(CleanStoppedSessionTask, _BaseTask_1$default);

  var _super = _createSuper(CleanStoppedSessionTask);

  function CleanStoppedSessionTask(context) {
    var _this;

    _classCallCheck(this, CleanStoppedSessionTask);

    _this = _super.call(this, context.logger);
    _this.context = context;
    _this.taskName = 'CleanStoppedSessionTask';
    _this.taskCanceler = null;
    return _this;
  }

  _createClass(CleanStoppedSessionTask, [{
    key: "cancel",
    value: function cancel() {
      if (this.taskCanceler) {
        this.taskCanceler.cancel();
        this.taskCanceler = null;
      }
    }
  }, {
    key: "run",
    value: function run() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var _iterator, _step, observer, tile;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                if (!this.context.signalingClient.ready()) {
                  _context.next = 5;
                  break;
                }

                this.context.signalingClient.closeConnection();
                _context.next = 5;
                return this.receiveWebSocketClosedEvent();

              case 5:
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);
                throw _context.t0;

              case 10:
                _context.prev = 10;
                _iterator = _createForOfIteratorHelper(this.context.removableObservers);

                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    observer = _step.value;
                    observer.removeObserver();
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }

                this.context.statsCollector.stop();
                this.context.statsCollector = null;
                this.context.connectionMonitor.stop();
                this.context.connectionMonitor = null;

                if (this.context.peer) {
                  this.context.peer.close();
                }

                this.context.peer = null;
                this.context.localVideoSender = null;
                this.context.sdpAnswer = null;
                this.context.sdpOfferInit = null;
                this.context.indexFrame = null;
                this.context.videoDownlinkBandwidthPolicy.reset();
                this.context.iceCandidateHandler = null;
                this.context.iceCandidates = [];
                this.context.turnCredentials = null;
                this.context.videoSubscriptions = null;
                this.context.transceiverController.reset();

                if (this.context.videoUplinkBandwidthPolicy.setTransceiverController) {
                  this.context.videoUplinkBandwidthPolicy.setTransceiverController(undefined);
                }

                if (this.context.videoDownlinkBandwidthPolicy.bindToTileController) {
                  this.context.videoDownlinkBandwidthPolicy.bindToTileController(undefined);
                }

                tile = this.context.videoTileController.getLocalVideoTile();

                if (tile) {
                  tile.bindVideoStream('', true, null, null, null, null);
                }

                this.context.videoTileController.removeAllVideoTiles();
                return _context.finish(10);

              case 35:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 7, 10, 35]]);
      }));
    }
  }, {
    key: "receiveWebSocketClosedEvent",
    value: function receiveWebSocketClosedEvent() {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        var Interceptor = /*#__PURE__*/function () {
          function Interceptor(signalingClient) {
            _classCallCheck(this, Interceptor);

            this.signalingClient = signalingClient;
          }

          _createClass(Interceptor, [{
            key: "cancel",
            value: function cancel() {
              this.signalingClient.removeObserver(this);
              reject(new Error("CleanStoppedSessionTask got canceled while waiting for the WebSocket closed event"));
            }
          }, {
            key: "handleSignalingClientEvent",
            value: function handleSignalingClientEvent(event) {
              if (event.type === SignalingClientEventType_1.default.WebSocketClosed) {
                this.signalingClient.removeObserver(this);
                resolve();
              }
            }
          }]);

          return Interceptor;
        }();

        var interceptor = new Interceptor(_this2.context.signalingClient);
        _this2.taskCanceler = interceptor;

        _this2.context.signalingClient.registerObserver(interceptor);
      });
    }
  }]);

  return CleanStoppedSessionTask;
}(BaseTask_1.default);

exports.default = CleanStoppedSessionTask;